var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.36804V14.8684C15.75 15.1668 15.6315 15.4529 15.4205 15.6639C15.2095 15.8749 14.9234 15.9934 14.625 15.9934H11.8125C11.5141 15.9934 11.228 15.8749 11.017 15.6639C10.806 15.4529 10.6875 15.1668 10.6875 14.8684V12.0559C10.6875 11.9067 10.6282 11.7637 10.5227 11.6582C10.4173 11.5527 10.2742 11.4934 10.125 11.4934H7.875C7.72582 11.4934 7.58274 11.5527 7.47725 11.6582C7.37176 11.7637 7.3125 11.9067 7.3125 12.0559V14.8684C7.3125 15.1668 7.19397 15.4529 6.983 15.6639C6.77202 15.8749 6.48587 15.9934 6.1875 15.9934H3.375C3.07663 15.9934 2.79048 15.8749 2.5795 15.6639C2.36853 15.4529 2.25 15.1668 2.25 14.8684V8.36804C2.24998 8.21234 2.28227 8.05833 2.34485 7.91576C2.40742 7.77318 2.4989 7.64515 2.61352 7.53976L8.23852 2.23257L8.24625 2.22484C8.45335 2.0365 8.72323 1.93213 9.00316 1.93213C9.2831 1.93213 9.55298 2.0365 9.76008 2.22484C9.76248 2.22759 9.76506 2.23017 9.76781 2.23257L15.3928 7.53976C15.5063 7.64571 15.5966 7.77399 15.6581 7.91654C15.7195 8.05908 15.7508 8.21281 15.75 8.36804Z",
    fill: "#297DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBlue);
export default __webpack_public_path__ + "static/media/house-blue.e698f554ff5fa4ad570e2d1285d5135b.svg";
export { ForwardRef as ReactComponent };